import React from "react";
const Ticket: React.FC = () => (
  <svg
    width="66"
    height="66"
    viewBox="0 0 66 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M56.7188 19.2844C55.3516 20.3815 53.6275 20.9354 51.8771 20.8397C50.1268 20.7441 48.4733 20.0057 47.2338 18.7662C45.9943 17.5267 45.2559 15.8732 45.1603 14.1229C45.0647 12.3725 45.6185 10.6484 46.7156 9.28125L39.4969 2.0625L2.0625 39.4969L9.28125 46.7156C10.6484 45.6185 12.3725 45.0647 14.1229 45.1603C15.8732 45.2559 17.5267 45.9943 18.7662 47.2338C20.0057 48.4733 20.7441 50.1268 20.8397 51.8771C20.9354 53.6275 20.3815 55.3516 19.2844 56.7188L26.5031 63.9375L63.9375 26.5031L56.7188 19.2844Z"
      stroke="#2E83FA"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.3898 49.5L30.8336 50.9438M35.1648 15.0563L36.6086 16.5L35.1648 15.0563ZM40.9398 20.7281L42.3836 22.1719L40.9398 20.7281ZM46.7148 26.5031L48.1586 27.9469L46.7148 26.5031ZM52.3867 32.2781L53.8305 33.7219L52.3867 32.2781ZM12.168 32.2781L13.6117 33.7219L12.168 32.2781ZM17.8398 38.0532L19.2836 39.4969L17.8398 38.0532ZM23.6148 43.8281L25.0586 45.2719L23.6148 43.8281Z"
      stroke="#2E83FA"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Ticket;
